import { captureException } from '@sentry/react';
import { store } from '.';
import { getBalanceQuery } from '../lib/get-balance-query';
import { PlayerBalanceData } from '../types/api';
import { xFetch } from '../lib/xfetch';

const { $set, get } = store;

export const refreshBalance = async () => {
    // aborters.spin covers the entire spin lifecycle — from the moment the user clicks Spin
    // until the last reel stops and results are applied. If a balance:refresh arrives
    // anywhere in that window, calling /api/getGame could reset server-side game state
    // and cause "Game Invalid."
    if (get().aborters.spin) {
        return;
    }

    try {
        const query = getBalanceQuery();
        const fetched = await xFetch('/api/player/balance?' + query);
        const data: PlayerBalanceData = await fetched.json();

        $set((state) => {
            state.cash = Number(data.cashValue);
            state.bonus = Number(data.bonusBalance);
            state.value = Number(data.accountValue);
        });
    } catch (error) {
        captureException(error);
    }
};
